/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_Builder_LabelInputs */

const en_ui_filter_builder_label = /** @type {(inputs: Ui_Filter_Builder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe a filter`)
};

const de_ui_filter_builder_label = /** @type {(inputs: Ui_Filter_Builder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter beschreiben`)
};

/**
* | output |
* | --- |
* | "Describe a filter" |
*
* @param {Ui_Filter_Builder_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_builder_label = /** @type {((inputs?: Ui_Filter_Builder_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Builder_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_builder_label(inputs)
	return de_ui_filter_builder_label(inputs)
});